module.exports = __webpack_public_path__ + "static/media/Banner1-882c0b4b.9cd619c9.jpg";